export default "__VITE_ASSET__B1IF2iTe__"